import { cn } from '../../lib/utils';

export const KPICard = ({ title, value, subtitle, icon: Icon, trend, className }) => {
    return (
        <div 
            className={cn('kpi-card animate-fade-in', className)}
            data-testid="kpi-card"
        >
            <div className="flex items-start justify-between">
                <div>
                    <p className="mono-label mb-2">{title}</p>
                    <p className="text-4xl font-bold tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                        {value}
                    </p>
                    {subtitle && (
                        <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
                    )}
                    {trend && (
                        <p className={cn(
                            'text-xs font-medium mt-2',
                            trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-muted-foreground'
                        )}>
                            {trend > 0 ? '+' : ''}{trend}% from last month
                        </p>
                    )}
                </div>
                {Icon && (
                    <div className="w-12 h-12 bg-primary/10 rounded-sm flex items-center justify-center">
                        <Icon className="w-6 h-6 text-primary" />
                    </div>
                )}
            </div>
        </div>
    );
};
